import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const PlaceholderIcon = (props: PosIconProps) => {
  return (
    <SvgWrapper aria-label="placeholder-icon" {...props} viewBox="0 0 16 16">
      <path
        d="M7.60001 13.2001V14.4001H4.80001V13.2001H7.60001ZM2.80001 8.8001V11.2001H1.60001V8.8001H2.80001ZM14.4 5.6001V8.0001H13.2V5.6001H14.4ZM9.20001 2.4001V3.6001H6.80001V2.4001H9.20001Z"
        fill="inherit"
      />
      <path d="M11.2 13.2001V14.4001H8.40001V13.2001H11.2Z" fill="inherit" />
      <path
        d="M2.80001 12.0001C2.80001 12.6628 3.33726 13.2001 4.00001 13.2001V14.4001L3.87657 14.397C2.64933 14.3348 1.66531 13.3508 1.60313 12.1235L1.60001 12.0001H2.80001Z"
        fill="inherit"
      />
      <path d="M2.80001 5.6001V8.0001H1.60001V5.6001H2.80001Z" fill="inherit" />
      <path
        d="M12 13.2001V14.4001C13.3255 14.4001 14.4 13.3256 14.4 12.0001H13.2C13.2 12.6628 12.6627 13.2001 12 13.2001Z"
        fill="white"
      />
      <path d="M14.4 8.8001V11.2001H13.2V8.8001H14.4Z" fill="inherit" />
      <path
        d="M8.99995 7.0001C8.99995 6.44781 8.55224 6.0001 7.99995 6.0001C7.65718 6.0001 7.35469 6.17255 7.17452 6.43543C6.98718 6.70877 6.73132 7.0001 6.39995 7.0001C6.06858 7.0001 5.79165 6.72646 5.88074 6.40729C6.13953 5.48021 6.99032 4.8001 7.99995 4.8001C9.21498 4.8001 10.2 5.78507 10.2 7.0001C10.2 8.00682 9.52293 8.85272 8.59995 9.11416V9.6001C8.59995 9.93147 8.33132 10.2001 7.99995 10.2001C7.66858 10.2001 7.39995 9.93147 7.39995 9.6001V8.6001C7.39995 8.26873 7.66858 8.0001 7.99995 8.0001C8.55224 8.0001 8.99995 7.55238 8.99995 7.0001Z"
        fill="inherit"
      />
      <path
        d="M8.79995 11.6001C8.79995 12.0419 8.44178 12.4001 7.99995 12.4001C7.55812 12.4001 7.19995 12.0419 7.19995 11.6001C7.19995 11.1583 7.55812 10.8001 7.99995 10.8001C8.44178 10.8001 8.79995 11.1583 8.79995 11.6001Z"
        fill="inherit"
      />
      <path
        d="M5.40001 2.20014C5.40001 1.86877 5.13138 1.6001 4.80001 1.6001C4.46864 1.6001 4.20001 1.86873 4.20001 2.2001V2.4001H4.00001C2.67452 2.4001 1.60001 3.47461 1.60001 4.8001H2.80001C2.80001 4.13736 3.33726 3.6001 4.00001 3.6001H4.20001V4.2001C4.20001 4.53147 4.46864 4.8001 4.80001 4.8001C5.13138 4.8001 5.40001 4.53147 5.40001 4.2001V3.6001H6.00001V2.4001H5.40001V2.20014Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8 2.2001V2.4001H12C13.3255 2.4001 14.4 3.47461 14.4 4.8001H13.2C13.2 4.13736 12.6627 3.6001 12 3.6001H11.8V4.2001C11.8 4.53147 11.5314 4.8001 11.2 4.8001C10.8686 4.8001 10.6 4.53147 10.6 4.2001V3.6001H10V2.4001H10.6V2.20019C10.6 1.86882 10.8686 1.6001 11.2 1.6001C11.5314 1.6001 11.8 1.86873 11.8 2.2001Z"
        fill="inherit"
      />
    </SvgWrapper>
  );
};
